import { useEffect } from 'react';
import { scrollToTop as scrollToTopUtil } from '@/utils/helpers';

export const useScrollToTop = (deps = [], options = {}) => {
  useEffect(() => {
    scrollToTopUtil(options);
  }, deps);
};

